export default {
    key: 'p2p',
    common: {
        productName: 'core.productNames.p2p',
        splashMessage: 'offerFlow.splashMessage.p2p',
        headingAside: 'offerFlow.headingAside.p2p',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.p2p',
    },
    stepTripSelection: {
        heading: 'offerFlow.pages.stepTripSelection.heading.common',
        body: 'offerFlow.p2p.dayTicket',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.p2p',
        body: 'offerFlow.pages.stepPassengers.body.withReductions',
    },
} satisfies OfferFlowContent;
